import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { Title } from 'root/admin/components';

import store from 'root/admin/store';
import { Form, Field, Loader } from '@smartplatform/ui';

const Ticker = () => {
	const [record, setRecord] = useState();

	const init = async () => {
		const data = await store.model.Ticker.find()
			.then(res => {
				console.log(res);
				return res;
			})
			.catch(err => console.error('Got error', err));
		if (data.length > 0) {
			setRecord(data[0]);
		} else {
			setRecord(new store.model.Ticker());
		}
	};

	useEffect(() => {
		init();
	}, []);

	if (!record) {
		return <Loader />;
	}

	console.log('record', record);
	return (
		<div>
			<Title record={record} name="Бегущая строка" />
			<Form record={record} rootPath="/admin" stay onSave={() => store.history.push(`/admin/ticker`)}>
				<Field property="text" label="Содержимое бегущей строки">
					<textarea rows="10" cols="45" />
				</Field>
				<Field property="show" label="Показывать бегущую строку" />
			</Form>
		</div>
	);
};

export default withRouter(Ticker);
